<template>
  <div class="text-left">
    <div v-if="!hasOffers">
      <b-alert variant="info" :show="true">
        Sorry! There is no offers for booking.
      </b-alert>
    </div>
    <div>
      <b-form @submit.prevent="submit">
        <div v-if="false">
          <div v-if="model.passportCopy">
            <img :src="previewPassportCopy" alt="" />
          </div>
          <input type="file" @change="onChange_PassportCopy" />
        </div>
        <div class="row">
          <div class="col-md text-center">
            <div class="m-0 mb-3" style="display:inline-block;">
              <b-form-group
                class="my-3 mr-4"
                id="input-group-1"
                label-for="input-1"
              >
                <b-form-radio
                  :value="true"
                  v-model="model.euApplicant"
                  name="eu-applicant"
                >
                  <span class="bg-info text-white pt-1 pb-2 px-3 rounded"
                    >EU Student</span
                  >
                </b-form-radio>
              </b-form-group>
            </div>
            <div class="m-0 mb-3" style="display:inline-block;">
              <b-form-group class="my-3" id="input-group-1" label-for="input-1">
                <b-form-radio
                  :value="false"
                  v-model="model.euApplicant"
                  name="eu-applicant"
                >
                  <span class="bg-success text-white pt-1 pb-2 px-3 rounded"
                    >NON EU Student</span
                  >
                </b-form-radio>
              </b-form-group>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <b-form-group
                id="input-group-4"
                :label="`I wish to start from`"
                label-for="input-4"
              >
                <b-form-input
                  v-model="model.intakeDate"
                  :id="`input-4`"
                  :type="`date`"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label for="input-group-0">Programme</label>
              <div class="mb-3">
                <v-select
                  id="input-group-0"
                  v-model="model.packageType"
                  label="title"
                  :options="offerProgrammeList"
                ></v-select>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md">
            <div class="mb-3">
              <label for="">{{ bookingLabel }}</label>
              <div>
                <v-select
                  v-model="model.package"
                  label="title"
                  :options="offerList"
                >
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!model.package"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
              </div>
            </div>
            <div
              class="my-3"
              v-if="model.package"
              v-html="model.package.description"
            ></div>
          </div>
        </div>
        <hr />
        <div class="my-3">
          <div class="row">
            <div class="col-6">
              <h3 v-if="getBooking && false" id="calculatedPrice">
                Total: &euro;{{ getTotalAmount | round }}
              </h3>
            </div>
            <div class="col text-right">
              <b-button
                v-if="getBooking.step > getBooking.firstStep"
                type="button"
                variant="default"
                @click="back()"
                >Back</b-button
              >
              <b-button type="submit" variant="primary">Next</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "../../filters";

export default {
  name: "BookingFor",
  props: {
    bookingType: {
      type: String,
      default: process.env.VUE_APP_BOOKING_TYPE
        ? process.env.VUE_APP_BOOKING_TYPE
        : "",
    },
  },
  data() {
    return {
      loading: false,
      model: null,
      previewPassportCopy: null,
    };
  },
  computed: {
    ...mapGetters(["getBooking", "getOffers", "getOfferProgrammes"]),
    bookingLabel() {
      let vm = this;
      if (vm.bookingType == "Paid Subscription") {
        return "Subscription";
      } else if (vm.bookingType != "") {
        return vm.bookingType;
      } else {
        return "Course";
      }
    },
    offerProgrammeList() {
      let vm = this;
      let ret = [];

      if (vm.getOfferProgrammes) {
        return vm.getOfferProgrammes;
      }

      return ret;
    },
    hasOfferProgrammes() {
      return this.offerProgrammeList.length > 0;
    },
    offerList() {
      let vm = this;
      let ret = [];

      if (vm.getOffers) {
        ret = vm.getOffers;

        if (vm.bookingType !== "") {
          ret = ret.filter((item) => {
            return item.type.toLowerCase() === vm.bookingType.toLowerCase();
          });
        }
        if (vm.model && vm.model.packageType) {
          ret = ret.filter((item) => {
            return item.program_id === vm.model.packageType.id;
          });
        }
      }

      return ret;
    },
    hasOffers() {
      return this.offerList.length > 0;
    },
    getTotalAmount() {
      if (this.model.package) {
        return this.model.euApplicant
          ? this.model.package.eu_price
          : this.model.package.regular_price;
      }
      return 0;
    },
  },
  methods: {
    ...mapActions(["saveBooking", "moveBookingBack", "moveBookingNext"]),
    async save() {
      let vm = this;
      vm.saveBooking(vm.model);
      vm.next();
    },
    submit() {
      let vm = this;
      // before save, check the validation

      if (!vm.model.intakeDate) {
        vm.$swal("Please let us know when do you want to start");
        return false;
      }

      if (!vm.model.package) {
        vm.$swal("Please select a package");
        return false;
      }

      // finally call save
      vm.save();
    },
    back() {
      // go back
      //const thisStep = this.model.step ? this.model.step : 1;
      //if (thisStep > 1) this.model.step = thisStep - 1;
      this.saveBooking(this.model);
      this.moveBookingBack();
      return false;
    },
    next() {
      // go to next
      //const thisStep = this.model.step ? this.model.step : 1;
      //if (thisStep > 0) this.model.step = thisStep + 1;

      //this.saveBooking(this.model);
      this.moveBookingNext();
      return false;
    },

    onChange_PassportCopy(e) {
      let vm = this;
      let files = e.target.files || e.dataTransfer.files;
      vm.model.passportCopy = files[0];
      vm.renderPreview("passportCopy");
    },
    renderPreview(name) {
      let vm = this;
      let reader = new FileReader();
      reader.onload = (e) => {
        if (name === "passportCopy") vm.previewPassportCopy = e.target.result;
      };

      let file = null;
      if (name === "passportCopy") file = vm.model.passportCopy;

      if (file) reader.readAsDataURL(file);
    },
  },
  created() {
    let vm = this;
    if (vm.getBooking) {
      vm.model = JSON.parse(JSON.stringify(vm.getBooking));
    }

    if (vm.model && !vm.model.euApplicant) {
      vm.model.euApplicant = false;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
